/* Global theme JS: drawers, AJAX cart, quick add, product form, sticky ATC. */
(function () {
  'use strict';

  var routes = window.themeRoutes || {
    cart_add_url: '/cart/add',
    cart_change_url: '/cart/change',
    cart_update_url: '/cart/update',
    cart_url: '/cart'
  };

  /* ----------------------------------------------------------------
     Drawers (cart + mobile menu)
  ---------------------------------------------------------------- */
  function getDrawer(id) {
    return document.getElementById(id);
  }

  function openDrawer(id) {
    var drawer = getDrawer(id);
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');
    var focusable = drawer.querySelector('button, a, input, select');
    if (focusable) focusable.focus();
  }

  function closeDrawer(id) {
    var drawer = getDrawer(id);
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overflow-hidden');
  }

  function closeAllDrawers() {
    document.querySelectorAll('.drawer.is-open').forEach(function (d) {
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
    });
    document.body.classList.remove('overflow-hidden');
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-drawer-open]');
    if (opener) {
      event.preventDefault();
      openDrawer(opener.getAttribute('data-drawer-open'));
      return;
    }
    var closer = event.target.closest('[data-drawer-close]');
    if (closer) {
      event.preventDefault();
      closeDrawer(closer.getAttribute('data-drawer-close'));
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAllDrawers();
  });

  /* ----------------------------------------------------------------
     Sticky header + transparent header solidify on scroll
  ---------------------------------------------------------------- */
  function setSiteHeaderHeight(header) {
    var section = header.closest('.header-section') || header;
    document.documentElement.style.setProperty('--site-header-height', section.offsetHeight + 'px');
  }

  function initStickyHeader(header) {
    if (!header.classList.contains('is-sticky')) return;

    /* Sticky must be applied to Shopify's section wrapper (see base.css) */
    var shopifySection = header.closest('.shopify-section');
    if (shopifySection) shopifySection.classList.add('shopify-section--sticky-header');

    setSiteHeaderHeight(header);
    window.addEventListener('resize', function () {
      setSiteHeaderHeight(header);
    });

    if (header.getAttribute('data-sticky-mode') === 'scroll_up') {
      var wrapper = header.closest('.header-section') || header;
      var lastY = window.scrollY;
      window.addEventListener('scroll', function () {
        var y = window.scrollY;
        /* Keep visible near the top and while any drawer is open */
        if (y < 100 || document.body.classList.contains('overflow-hidden')) {
          wrapper.classList.remove('is-hidden');
        } else if (y > lastY + 2) {
          wrapper.classList.add('is-hidden');
        } else if (y < lastY - 2) {
          wrapper.classList.remove('is-hidden');
        }
        lastY = y;
      }, { passive: true });
    }

    if (!header.hasAttribute('data-transparent-header')) return;

    var onHeaderScroll = function () {
      header.classList.toggle('is-solid', window.scrollY > 24);
    };
    window.addEventListener('scroll', onHeaderScroll, { passive: true });
    onHeaderScroll();
  }

  document.querySelectorAll('.site-header.is-sticky').forEach(initStickyHeader);

  /* ----------------------------------------------------------------
     Image autoscroll: manual mode arrows
  ---------------------------------------------------------------- */
  document.addEventListener('click', function (event) {
    var arrow = event.target.closest('[data-autoscroll-arrow]');
    if (!arrow) return;
    var wrap = arrow.closest('.autoscroll');
    var track = wrap && wrap.querySelector('.autoscroll__track');
    if (!track) return;
    var card = track.querySelector('.autoscroll__card');
    var gap = parseInt(getComputedStyle(wrap).getPropertyValue('--as-gap'), 10) || 16;
    var amount = card ? card.offsetWidth + gap : 320;
    if (arrow.getAttribute('data-autoscroll-arrow') === 'prev') amount = -amount;
    track.scrollBy({ left: amount, behavior: 'smooth' });
  });

  /* ----------------------------------------------------------------
     Search toggle
  ---------------------------------------------------------------- */
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-search-toggle]');
    if (!toggle) return;
    event.preventDefault();
    var bar = document.getElementById('HeaderSearchBar');
    if (!bar) return;
    bar.classList.toggle('is-open');
    if (bar.classList.contains('is-open')) {
      var input = bar.querySelector('input[type="search"]');
      if (input) input.focus();
    }
  });

  /* ----------------------------------------------------------------
     AJAX cart
  ---------------------------------------------------------------- */
  /* The header lives in a section group, so its section ID is dynamic —
     read it from the DOM instead of hardcoding 'header'. */
  var CART_SECTIONS = ['cart-drawer'];
  var headerSectionEl = document.querySelector('[data-header-section-id]');
  if (headerSectionEl) CART_SECTIONS.push(headerSectionEl.getAttribute('data-header-section-id'));

  window.themeCartSections = CART_SECTIONS;

  window.qualifyingSpendCentsFromCart = function (cart) {
    if (!cart || !Array.isArray(cart.items)) return 0;
    var total = 0;
    cart.items.forEach(function (item) {
      var props = (item && item.properties) || {};
      if (props._drawer_gift_selector) return;
      var price = typeof item.original_line_price === 'number' ? item.original_line_price :
        typeof item.final_line_price === 'number' ? item.final_line_price : 0;
      total += price;
    });
    return total;
  };

  function refreshCartSections(sections) {
    if (!sections) return;
    CART_SECTIONS.forEach(function (sectionId) {
      var html = sections[sectionId];
      if (!html) return;
      var incoming = new DOMParser().parseFromString(html, 'text/html');
      if (sectionId === 'cart-drawer') {
        var current = document.getElementById('CartDrawerContent');
        var next = incoming.getElementById('CartDrawerContent');
        if (current && next) current.innerHTML = next.innerHTML;
      } else {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          var nextCount = incoming.querySelector('[data-cart-count]');
          if (nextCount) el.textContent = nextCount.textContent;
        });
      }
    });
    document.dispatchEvent(new CustomEvent('cart:updated'));
  }

  window.themeCartRefreshSections = refreshCartSections;

  function cartRequest(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) throw data;
        return data;
      });
    });
  }

  /* Re-render cart sections from the server (used to recover after a failed mutation). */
  function syncCartSections() {
    return fetch(window.location.pathname + '?sections=' + CART_SECTIONS.join(','))
      .then(function (response) { return response.json(); })
      .then(refreshCartSections)
      .catch(function () {});
  }

  function addToCart(items, openCart) {
    return cartRequest(routes.cart_add_url + '.js', {
      items: items,
      sections: CART_SECTIONS.join(','),
      sections_url: window.location.pathname
    }).then(function (data) {
      refreshCartSections(data.sections);
      if (openCart !== false) openDrawer('CartDrawer');
      return data;
    });
  }

  function changeLine(key, quantity) {
    return cartRequest(routes.cart_change_url + '.js', {
      id: key,
      quantity: quantity,
      sections: CART_SECTIONS.join(','),
      sections_url: window.location.pathname
    }).then(function (data) {
      refreshCartSections(data.sections);
      if (window.location.pathname.indexOf(routes.cart_url) === 0) {
        window.location.reload();
      }
      return data;
    });
  }

  window.themeCart = { add: addToCart, change: changeLine, openDrawer: openDrawer };

  /* Cart drawer line quantity / remove (event delegation survives re-render) */
  document.addEventListener('click', function (event) {
    var qtyBtn = event.target.closest('[data-qty-change]');
    if (qtyBtn) {
      var line = qtyBtn.closest('[data-line-key]');
      if (!line) return;
      var input = line.querySelector('.qty__input');
      if (!input) return;
      var next = parseInt(input.value, 10) + parseInt(qtyBtn.getAttribute('data-qty-change'), 10);
      if (next < 0) next = 0;
      input.value = next;
      changeLine(line.getAttribute('data-line-key'), next).catch(syncCartSections);
      return;
    }
    var removeBtn = event.target.closest('[data-line-remove]');
    if (removeBtn) {
      var removeLine = removeBtn.closest('[data-line-key]');
      if (removeLine) changeLine(removeLine.getAttribute('data-line-key'), 0).catch(syncCartSections);
      return;
    }
    var giftRemoveBtn = event.target.closest('[data-gift-remove]');
    if (giftRemoveBtn) {
      var giftLine = giftRemoveBtn.closest('[data-line-key]');
      if (!giftLine) return;
      if (window.__autoGiftRejectTier) {
        window.__autoGiftRejectTier(
          giftLine.getAttribute('data-gift-block'),
          giftLine.getAttribute('data-gift-tier') || '1'
        );
      }
      changeLine(giftLine.getAttribute('data-line-key'), 0).catch(syncCartSections);
    }
  });

  document.addEventListener('change', function (event) {
    var input = event.target.closest('.cart-line .qty__input');
    if (!input) return;
    var line = input.closest('[data-line-key]');
    if (!line) return;
    var qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < 0) qty = 0;
    changeLine(line.getAttribute('data-line-key'), qty).catch(syncCartSections);
  });

  /* Terms agreement checkbox — unlocks the checkout + quick payment buttons */
  document.addEventListener('change', function (event) {
    var terms = event.target.closest('[data-cart-terms]');
    if (!terms) return;
    var footer = terms.closest('.drawer__footer');
    if (!footer) return;
    footer.querySelectorAll('[data-requires-terms]').forEach(function (button) {
      button.disabled = !terms.checked;
    });
    footer.querySelectorAll('[data-requires-terms-show]').forEach(function (el) {
      el.hidden = !terms.checked;
    });
  });

  /* Cart note */
  document.addEventListener('change', function (event) {
    var note = event.target.closest('[data-cart-note]');
    if (!note) return;
    fetch(routes.cart_update_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: note.value })
    }).catch(function () {});
  });

  /* Upsell add buttons */
  document.addEventListener('click', function (event) {
    var upsell = event.target.closest('[data-upsell-add]');
    if (!upsell) return;
    event.preventDefault();
    upsell.classList.add('is-loading');
    addToCart([{ id: parseInt(upsell.getAttribute('data-upsell-add'), 10), quantity: 1 }]).catch(function () {
      syncCartSections();
    }).finally(function () {
      upsell.classList.remove('is-loading');
    });
  });

  /* ----------------------------------------------------------------
     Product forms (main + sticky) — AJAX submit
  ---------------------------------------------------------------- */
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[data-product-form]');
    if (!form) return;
    event.preventDefault();
    var button = form.querySelector('[type="submit"]');
    var id = parseInt(form.querySelector('[name="id"]').value, 10);
    /* The sticky ATC form has no quantity field of its own — fall back to the main form's. */
    var qtyField = form.querySelector('[name="quantity"]') ||
      document.querySelector('form[data-product-form][data-main-form] [name="quantity"]');
    var qty = qtyField ? parseInt(qtyField.value, 10) || 1 : 1;
    if (button) button.classList.add('is-loading');
    addToCart([{ id: id, quantity: qty }]).catch(function (error) {
      var message = (error && error.description) || 'Unable to add to cart';
      var messageEl = form.querySelector('[data-form-message]');
      if (messageEl) {
        messageEl.textContent = message;
        messageEl.classList.add('form-message--error');
      } else {
        window.alert(message);
      }
    }).finally(function () {
      if (button) button.classList.remove('is-loading');
    });
  });

  /* ----------------------------------------------------------------
     Quick view (+ button on product cards)
  ---------------------------------------------------------------- */
  var qvModal = document.getElementById('QuickViewModal');
  var moneyFormat = window.themeMoneyFormat || '${{amount}}';

  function formatMoney(cents) {
    var placeholder = (moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/) || [null, 'amount'])[1];
    var delimited = function (decimals, thousands, decimal) {
      var parts = (cents / 100).toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    };
    var value;
    switch (placeholder) {
      case 'amount_no_decimals': value = delimited(0, ',', '.'); break;
      case 'amount_with_comma_separator': value = delimited(2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = delimited(0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = delimited(2, "'", '.'); break;
      default: value = delimited(2, ',', '.');
    }
    return moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  var qvState = { product: null, selected: [] };

  function qvOptionName(product, index) {
    var option = product.options[index];
    if (option == null) return '';
    if (typeof option === 'string') return option;
    if (typeof option === 'object' && option.name) return option.name;
    return String(option);
  }

  function qvOptionValues(product, optionIndex) {
    var seen = [];
    product.variants.forEach(function (variant) {
      var value = variant.options[optionIndex];
      if (value == null || seen.indexOf(value) > -1) return;
      seen.push(value);
    });
    return seen;
  }

  function qvShouldHideOptions(product) {
    if (!product.variants || product.variants.length === 0) return true;
    if (product.variants.length === 1) {
      var variant = product.variants[0];
      if (!variant.options || variant.options.length === 0) return true;
      if (variant.options.length === 1) {
        var name = qvOptionName(product, 0);
        var value = variant.options[0];
        if (name === 'Title' && (value === 'Default Title' || value === 'Default')) return true;
      }
    }
    return false;
  }

  function qvPriceCents(price) {
    if (price == null) return 0;
    if (typeof price === 'number') return price;
    if (typeof price === 'object' && price.amount != null) {
      return Math.round(parseFloat(price.amount, 10) * 100);
    }
    return parseInt(price, 10) || 0;
  }

  function qvVariantFor(options) {
    return qvState.product.variants.find(function (variant) {
      return variant.options.every(function (value, index) {
        return options[index] === value;
      });
    });
  }

  function qvUpdate() {
    var variant = qvVariantFor(qvState.selected);

    var priceEl = qvModal.querySelector('[data-qv-price]');
    priceEl.innerHTML = '';
    if (variant) {
      var price = document.createElement('span');
      price.textContent = formatMoney(qvPriceCents(variant.price));
      if (variant.compare_at_price && qvPriceCents(variant.compare_at_price) > qvPriceCents(variant.price)) {
        price.className = 'price__sale';
        var compare = document.createElement('s');
        compare.className = 'price__compare';
        compare.textContent = formatMoney(qvPriceCents(variant.compare_at_price));
        priceEl.appendChild(price);
        priceEl.appendChild(compare);
      } else {
        priceEl.appendChild(price);
      }
    }

    qvModal.querySelectorAll('[data-qv-option]').forEach(function (pill) {
      var index = parseInt(pill.getAttribute('data-qv-option'), 10);
      var value = pill.getAttribute('data-value');
      var candidate = qvState.selected.slice();
      candidate[index] = value;
      var candidateVariant = qvVariantFor(candidate);
      pill.classList.toggle('is-unavailable', !candidateVariant || !candidateVariant.available);
      pill.classList.toggle('is-active', qvState.selected[index] === value);
      pill.setAttribute('aria-pressed', qvState.selected[index] === value ? 'true' : 'false');
    });

    qvModal.querySelectorAll('[data-qv-option-value]').forEach(function (label) {
      var index = parseInt(label.getAttribute('data-qv-option-value'), 10);
      label.textContent = qvState.selected[index] || '';
    });

    var button = qvModal.querySelector('[data-qv-add]');
    var label = button.querySelector('.btn-label');
    if (!variant) {
      button.disabled = true;
      label.textContent = button.getAttribute('data-text-unavailable');
    } else if (!variant.available) {
      button.disabled = true;
      label.textContent = button.getAttribute('data-text-soldout');
    } else {
      button.disabled = false;
      label.textContent = button.getAttribute('data-text-add');
    }
  }

  function openQuickView(product) {
    qvState.product = product;
    var initial = product.variants.find(function (v) { return v.available; }) || product.variants[0];
    qvState.selected = initial.options.slice();

    qvModal.querySelector('[data-qv-title]').textContent = product.title;
    qvModal.querySelector('[data-qv-link]').href = product.url;

    var media = qvModal.querySelector('[data-qv-media]');
    media.innerHTML = '';

    function appendImage(src) {
      var img = document.createElement('img');
      img.loading = 'lazy';
      img.alt = product.title;
      img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=720';
      media.appendChild(img);
    }

    /* Prefer product.media so hosted videos show in the quick view;
       external videos and 3D models fall back to their preview image.
       Older cached payloads without media keep the images-only path. */
    if (Array.isArray(product.media) && product.media.length) {
      product.media.forEach(function (item) {
        if (item.media_type === 'video' && Array.isArray(item.sources)) {
          var mp4 = item.sources.filter(function (source) { return source.format === 'mp4'; }).pop();
          if (mp4) {
            var video = document.createElement('video');
            video.controls = true;
            video.muted = true;
            video.playsInline = true;
            video.preload = 'metadata';
            if (item.preview_image && item.preview_image.src) video.poster = item.preview_image.src;
            video.src = mp4.url;
            media.appendChild(video);
            return;
          }
        }
        var src = item.preview_image && item.preview_image.src ? item.preview_image.src : item.src;
        if (src) appendImage(src);
      });
    } else {
      product.images.forEach(appendImage);
    }
    media.scrollLeft = 0;

    /* Pause any playing quick-view video once it's scrolled off */
    media.addEventListener('scroll', function () {
      media.querySelectorAll('video').forEach(function (video) {
        if (video.paused) return;
        var box = video.getBoundingClientRect();
        var frame = media.getBoundingClientRect();
        if (box.right < frame.left + 10 || box.left > frame.right - 10) video.pause();
      });
    }, { passive: true });

    var optionsWrap = qvModal.querySelector('[data-qv-options]');
    optionsWrap.innerHTML = '';
    if (!qvShouldHideOptions(product)) {
      product.options.forEach(function (option, index) {
        var name = qvOptionName(product, index);
        var group = document.createElement('div');
        group.className = 'option-group';
        group.setAttribute('data-qv-option-group', index);

        var groupLabel = document.createElement('div');
        groupLabel.className = 'option-group__label';
        var nameEl = document.createElement('span');
        nameEl.textContent = name;
        var valueEl = document.createElement('span');
        valueEl.className = 'option-group__value';
        valueEl.setAttribute('data-qv-option-value', index);
        valueEl.textContent = qvState.selected[index] || '';
        groupLabel.appendChild(nameEl);
        groupLabel.appendChild(valueEl);
        group.appendChild(groupLabel);

        var pills = document.createElement('div');
        pills.className = 'option-pills';
        qvOptionValues(product, index).forEach(function (value) {
          var pill = document.createElement('button');
          pill.type = 'button';
          pill.className = 'qv-pill';
          pill.setAttribute('data-qv-option', index);
          pill.setAttribute('data-value', value);
          pill.textContent = value;
          pills.appendChild(pill);
        });
        group.appendChild(pills);
        optionsWrap.appendChild(group);
      });
    }

    var sizeFinderTrigger = qvModal.querySelector('[data-qv-size-finder]');
    if (sizeFinderTrigger) {
      var hasSizeOption = product.options.some(function (option) {
        var name = typeof option === 'object' && option.name ? option.name : option;
        return /size/i.test(name);
      });
      sizeFinderTrigger.hidden = !(document.getElementById('SizeFinderModal') && hasSizeOption);

      var sfButton = sizeFinderTrigger.querySelector('[data-size-finder-open]');
      if (sfButton && window.SizeFinder) {
        window.SizeFinder.setContextFromProduct(product);
        var ctx = window.SizeFinder.getContext();
        if (ctx.availableSizes && ctx.availableSizes.length) {
          sfButton.setAttribute('data-available-sizes', JSON.stringify(ctx.availableSizes));
        } else {
          sfButton.removeAttribute('data-available-sizes');
        }
        sfButton.removeAttribute('data-fit-profile');
        sfButton.removeAttribute('data-garment-type');
        /* Product JSON has no metafields, so per-product charts are product-page only */
        sfButton.removeAttribute('data-size-chart');
      }
    }

    qvUpdate();
    qvModal.showModal();
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-quick-view]');
    if (!trigger || !qvModal) return;
    event.preventDefault();
    trigger.classList.add('is-loading');
    fetch(trigger.getAttribute('data-quick-view') + '.js')
      .then(function (response) { return response.json(); })
      .then(openQuickView)
      .catch(function () {
        window.location.href = trigger.getAttribute('data-quick-view');
      })
      .finally(function () {
        trigger.classList.remove('is-loading');
      });
  });

  if (qvModal) {
    qvModal.addEventListener('click', function (event) {
      if (event.target === qvModal) {
        qvModal.close();
        return;
      }
      if (event.target.closest('[data-modal-close]')) {
        qvModal.close();
        return;
      }
      var pill = event.target.closest('[data-qv-option]');
      if (pill) {
        qvState.selected[parseInt(pill.getAttribute('data-qv-option'), 10)] = pill.getAttribute('data-value');
        qvUpdate();
      }
    });

    qvModal.querySelector('[data-qv-add]').addEventListener('click', function () {
      var variant = qvVariantFor(qvState.selected);
      if (!variant) return;
      var button = this;
      button.classList.add('is-loading');
      addToCart([{ id: variant.id, quantity: 1 }], false).then(function () {
        qvModal.close();
        openDrawer('CartDrawer');
      }).catch(function (error) {
        window.alert((error && error.description) || 'Unable to add to cart');
      }).finally(function () {
        button.classList.remove('is-loading');
      });
    });

    /* Apply the size finder recommendation to the quick view pills */
    document.addEventListener('sizefinder:result', function (event) {
      if (!qvModal.open || !qvState.product) return;
      var size = event.detail.size;
      var pill = qvModal.querySelector('[data-qv-option][data-value="' + CSS.escape(size) + '"]');
      if (pill) {
        qvState.selected[parseInt(pill.getAttribute('data-qv-option'), 10)] = size;
        qvUpdate();
      }
    });
  }

  /* ----------------------------------------------------------------
     Quantity selector (product page)
  ---------------------------------------------------------------- */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-qty-adjust]');
    if (!btn) return;
    var wrap = btn.closest('.qty');
    if (!wrap || btn.hasAttribute('data-qty-change')) return;
    var input = wrap.querySelector('.qty__input');
    var next = parseInt(input.value, 10) + parseInt(btn.getAttribute('data-qty-adjust'), 10);
    if (next < 1) next = 1;
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ----------------------------------------------------------------
     Sticky add-to-cart visibility
  ---------------------------------------------------------------- */
  var stickyBar = document.getElementById('StickyAtc');
  var mainButtons = document.querySelector('.product-form__buttons');
  if (stickyBar && mainButtons && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    observer.observe(mainButtons);
  }
})();
